<ng-container *ngIf="cs.vm$ | async as vm" [cmsContent]="vm.cmsContent">
  <dgx-cms-header
    [clientLogoNavigationLink]="navigationLink"
    [partnerLogo]="partnerLogo"
  />

  <main [ngClass]="{ main: !vm.isTablet }" id="main">
    <router-outlet />
  </main>

  <dgx-cms-footer />

  <dgx-components-modal-container />

  <dgx-notifications />
</ng-container>
